import { Section, SectionHead } from "../components/ui";
import { Reveal } from "../components/Reveal";
import { ProductShowcase } from "../components/ProductShowcase";
import { LabistaChat } from "../components/LabistaChat";
import { HazriCheckIn } from "../components/HazriCheckIn";
import { BrowserFrame } from "../components/BrowserFrame";
import { PRODUCTS, productBySlug } from "../data/products";

/**
 * The products, on the homepage.
 *
 * Each product gets the visual that tells the truth about it. Labista's
 * value is a conversation, so it gets the replay; Hazri Book's value is
 * the record that comes out the other end, so it gets a real screenshot of
 * the dashboard alongside the capture screen. Using the same treatment for
 * both would have flattered one and undersold the other.
 */
export function ProductsSection() {
  const labista = productBySlug("agent-labista");
  const hazri = productBySlug("hazri-book");

  return (
    <Section id="products">
      <div className="container">
        <SectionHead
          eyebrow="Products"
          title={
            <>
              We don't just build software.{" "}
              <span className="text-gradient">We build products.</span>
            </>
          }
          lede="One is in production in Saudi Arabia, carrying a real payroll deadline every month. The other is still in the lab. We build few, and we say which is which."
        />

        <div className="mt-10 space-y-5 sm:mt-14">
          {labista ? (
            <Reveal>
              <ProductShowcase
                product={labista}
                secondaryHref="/contact"
                secondaryLabel="Book a demo"
                visual={<LabistaChat />}
              />
            </Reveal>
          ) : null}

          {hazri ? (
            <Reveal>
              <ProductShowcase
                product={hazri}
                reverse
                secondaryHref="/contact"
                secondaryLabel="Book a demo"
                visual={
                  <div className="space-y-4">
                    <BrowserFrame
                      src={hazri.shots![0].src}
                      alt={hazri.shots![0].alt}
                      label="Hazri Book · Company dashboard"
                    />
                    <div className="hidden justify-center lg:flex">
                      <div className="scale-[0.8] origin-top">
                        <HazriCheckIn />
                      </div>
                    </div>
                    <div className="flex justify-center lg:hidden">
                      <HazriCheckIn />
                    </div>
                  </div>
                }
              />
            </Reveal>
          ) : null}
        </div>

        {PRODUCTS.length > 2 ? null : (
          <Reveal delay={0.1}>
            <p className="mx-auto mt-8 max-w-2xl text-center text-sm text-white/40">
              More products are in the lab. We announce them when customers are
              using them, not before.
            </p>
          </Reveal>
        )}
      </div>
    </Section>
  );
}
